var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddLocation = function SvgAddLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "add-location_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#add-location_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M11.25 13.75h1.5v-3h3v-1.5h-3v-3h-1.5v3h-3v1.5h3zm.75 5.764q2.934-2.628 4.49-5.04t1.557-4.226q0-2.735-1.737-4.496T12 3.991q-2.574 0-4.311 1.761T5.95 10.248q0 1.814 1.557 4.226t4.491 5.04m0 1.995q-3.776-3.27-5.662-6.088T4.45 10.248q0-3.462 2.24-5.605Q8.93 2.5 11.998 2.5t5.309 2.143q2.24 2.144 2.24 5.605 0 2.356-1.887 5.173t-5.662 6.089"
  }))));
};
export default SvgAddLocation;